export default {
    SET_PATIENT_DATA(state, payload) {
        state.patientData = payload;
    }
};
